// ===================== TYPES =====================
export const SET_AVANCE_REQUEST_LOADING = "SET_AVANCE_REQUEST_LOADING";
export const CLEAR_AVANCE_REQUEST_MESSAGE = "CLEAR_AVANCE_REQUEST_MESSAGE";

// Mine
export const GET_MY_AVANCE_REQUESTS_REQUEST = "GET_MY_AVANCE_REQUESTS_REQUEST";
export const GET_MY_AVANCE_REQUESTS_SUCCESS = "GET_MY_AVANCE_REQUESTS_SUCCESS";
export const GET_MY_AVANCE_REQUESTS_FAIL = "GET_MY_AVANCE_REQUESTS_FAIL";

// Mine - En cours de remboursement
export const GET_MY_AVANCES_EN_COURS_REQUEST = "GET_MY_AVANCES_EN_COURS_REQUEST";
export const GET_MY_AVANCES_EN_COURS_SUCCESS = "GET_MY_AVANCES_EN_COURS_SUCCESS";
export const GET_MY_AVANCES_EN_COURS_FAIL = "GET_MY_AVANCES_EN_COURS_FAIL";

// Create
export const CREATE_AVANCE_REQUEST_REQUEST = "CREATE_AVANCE_REQUEST_REQUEST";
export const CREATE_AVANCE_REQUEST_SUCCESS = "CREATE_AVANCE_REQUEST_SUCCESS";
export const CREATE_AVANCE_REQUEST_FAIL = "CREATE_AVANCE_REQUEST_FAIL";

// Manager inbox
export const GET_MANAGER_AVANCE_INBOX_REQUEST = "GET_MANAGER_AVANCE_INBOX_REQUEST";
export const GET_MANAGER_AVANCE_INBOX_SUCCESS = "GET_MANAGER_AVANCE_INBOX_SUCCESS";
export const GET_MANAGER_AVANCE_INBOX_FAIL = "GET_MANAGER_AVANCE_INBOX_FAIL";

// Manager decision
export const MANAGER_AVANCE_DECISION_REQUEST = "MANAGER_AVANCE_DECISION_REQUEST";
export const MANAGER_AVANCE_DECISION_SUCCESS = "MANAGER_AVANCE_DECISION_SUCCESS";
export const MANAGER_AVANCE_DECISION_FAIL = "MANAGER_AVANCE_DECISION_FAIL";

// ✅ AJOUT: Manager history
export const GET_MANAGER_AVANCE_HISTORY_REQUEST = "GET_MANAGER_AVANCE_HISTORY_REQUEST";
export const GET_MANAGER_AVANCE_HISTORY_SUCCESS = "GET_MANAGER_AVANCE_HISTORY_SUCCESS";
export const GET_MANAGER_AVANCE_HISTORY_FAIL = "GET_MANAGER_AVANCE_HISTORY_FAIL";

// Admin inbox
export const GET_ADMIN_AVANCE_INBOX_REQUEST = "GET_ADMIN_AVANCE_INBOX_REQUEST";
export const GET_ADMIN_AVANCE_INBOX_SUCCESS = "GET_ADMIN_AVANCE_INBOX_SUCCESS";
export const GET_ADMIN_AVANCE_INBOX_FAIL = "GET_ADMIN_AVANCE_INBOX_FAIL";

// Admin decision
export const ADMIN_AVANCE_DECISION_REQUEST = "ADMIN_AVANCE_DECISION_REQUEST";
export const ADMIN_AVANCE_DECISION_SUCCESS = "ADMIN_AVANCE_DECISION_SUCCESS";
export const ADMIN_AVANCE_DECISION_FAIL = "ADMIN_AVANCE_DECISION_FAIL";

// Admin history
export const GET_ADMIN_AVANCE_HISTORY_REQUEST = "GET_ADMIN_AVANCE_HISTORY_REQUEST";
export const GET_ADMIN_AVANCE_HISTORY_SUCCESS = "GET_ADMIN_AVANCE_HISTORY_SUCCESS";
export const GET_ADMIN_AVANCE_HISTORY_FAIL = "GET_ADMIN_AVANCE_HISTORY_FAIL";

// Remboursement
export const ENREGISTRER_REMBOURSEMENT_REQUEST = "ENREGISTRER_REMBOURSEMENT_REQUEST";
export const ENREGISTRER_REMBOURSEMENT_SUCCESS = "ENREGISTRER_REMBOURSEMENT_SUCCESS";
export const ENREGISTRER_REMBOURSEMENT_FAIL = "ENREGISTRER_REMBOURSEMENT_FAIL";

// Remboursement anticipé
export const REMBOURSEMENT_ANTICIPE_REQUEST = "REMBOURSEMENT_ANTICIPE_REQUEST";
export const REMBOURSEMENT_ANTICIPE_SUCCESS = "REMBOURSEMENT_ANTICIPE_SUCCESS";
export const REMBOURSEMENT_ANTICIPE_FAIL = "REMBOURSEMENT_ANTICIPE_FAIL";

// ===================== HELPERS =====================
export const normalizeError = (err, fallback = "Erreur") => {
    if (!err) return fallback;
    if (typeof err === "string") return err;
    if (err?.message) return String(err.message);
    if (err?.error) return String(err.error);
    try {
        return JSON.stringify(err);
    } catch {
        return fallback;
    }
};

// ===================== COMMON =====================
export const setAvanceRequestLoading = (value) => ({
    type: SET_AVANCE_REQUEST_LOADING,
    payload: !!value,
});

export const clearAvanceRequestMessage = () => ({
    type: CLEAR_AVANCE_REQUEST_MESSAGE,
});

// ===================== MINE =====================
export const getMyAvanceRequestsRequest = () => ({
    type: GET_MY_AVANCE_REQUESTS_REQUEST,
});
export const getMyAvanceRequestsSuccess = (data) => ({
    type: GET_MY_AVANCE_REQUESTS_SUCCESS,
    payload: data,
});
export const getMyAvanceRequestsFail = (error) => ({
    type: GET_MY_AVANCE_REQUESTS_FAIL,
    payload: error,
});

// ===================== MINE - EN COURS =====================
export const getMyAvancesEnCoursRequest = () => ({
    type: GET_MY_AVANCES_EN_COURS_REQUEST,
});
export const getMyAvancesEnCoursSuccess = (data) => ({
    type: GET_MY_AVANCES_EN_COURS_SUCCESS,
    payload: data,
});
export const getMyAvancesEnCoursFail = (error) => ({
    type: GET_MY_AVANCES_EN_COURS_FAIL,
    payload: error,
});

// ===================== CREATE =====================
export const createAvanceRequestRequest = (payload) => ({
    type: CREATE_AVANCE_REQUEST_REQUEST,
    payload,
});
export const createAvanceRequestSuccess = (data) => ({
    type: CREATE_AVANCE_REQUEST_SUCCESS,
    payload: data,
});
export const createAvanceRequestFail = (error) => ({
    type: CREATE_AVANCE_REQUEST_FAIL,
    payload: error,
});

// ===================== MANAGER INBOX =====================
export const getManagerAvanceInboxRequest = () => ({
    type: GET_MANAGER_AVANCE_INBOX_REQUEST,
});
export const getManagerAvanceInboxSuccess = (data) => ({
    type: GET_MANAGER_AVANCE_INBOX_SUCCESS,
    payload: data,
});
export const getManagerAvanceInboxFail = (error) => ({
    type: GET_MANAGER_AVANCE_INBOX_FAIL,
    payload: error,
});

// ===================== MANAGER DECISION =====================
export const managerAvanceDecisionRequest = (payload) => ({
    type: MANAGER_AVANCE_DECISION_REQUEST,
    payload,
});
export const managerAvanceDecisionSuccess = (data) => ({
    type: MANAGER_AVANCE_DECISION_SUCCESS,
    payload: data,
});
export const managerAvanceDecisionFail = (error) => ({
    type: MANAGER_AVANCE_DECISION_FAIL,
    payload: error,
});

// ✅ AJOUT: Manager history actions
export const getManagerAvanceHistoryRequest = () => ({
    type: GET_MANAGER_AVANCE_HISTORY_REQUEST,
});
export const getManagerAvanceHistorySuccess = (data) => ({
    type: GET_MANAGER_AVANCE_HISTORY_SUCCESS,
    payload: data,
});
export const getManagerAvanceHistoryFail = (error) => ({
    type: GET_MANAGER_AVANCE_HISTORY_FAIL,
    payload: error,
});

// ===================== ADMIN INBOX =====================
export const getAdminAvanceInboxRequest = () => ({
    type: GET_ADMIN_AVANCE_INBOX_REQUEST,
});
export const getAdminAvanceInboxSuccess = (data) => ({
    type: GET_ADMIN_AVANCE_INBOX_SUCCESS,
    payload: data,
});
export const getAdminAvanceInboxFail = (error) => ({
    type: GET_ADMIN_AVANCE_INBOX_FAIL,
    payload: error,
});

// ===================== ADMIN DECISION =====================
export const adminAvanceDecisionRequest = (payload) => ({
    type: ADMIN_AVANCE_DECISION_REQUEST,
    payload,
});
export const adminAvanceDecisionSuccess = (data) => ({
    type: ADMIN_AVANCE_DECISION_SUCCESS,
    payload: data,
});
export const adminAvanceDecisionFail = (error) => ({
    type: ADMIN_AVANCE_DECISION_FAIL,
    payload: error,
});

// ===================== ADMIN HISTORY =====================
export const getAdminAvanceHistoryRequest = () => ({
    type: GET_ADMIN_AVANCE_HISTORY_REQUEST,
});
export const getAdminAvanceHistorySuccess = (data) => ({
    type: GET_ADMIN_AVANCE_HISTORY_SUCCESS,
    payload: data,
});
export const getAdminAvanceHistoryFail = (error) => ({
    type: GET_ADMIN_AVANCE_HISTORY_FAIL,
    payload: error,
});

// ===================== REMBOURSEMENT =====================
export const enregistrerRemboursementRequest = (payload) => ({
    type: ENREGISTRER_REMBOURSEMENT_REQUEST,
    payload,
});
export const enregistrerRemboursementSuccess = (data) => ({
    type: ENREGISTRER_REMBOURSEMENT_SUCCESS,
    payload: data,
});
export const enregistrerRemboursementFail = (error) => ({
    type: ENREGISTRER_REMBOURSEMENT_FAIL,
    payload: error,
});

// ===================== REMBOURSEMENT ANTICIPÉ =====================
export const remboursementAnticipeRequest = (payload) => ({
    type: REMBOURSEMENT_ANTICIPE_REQUEST,
    payload,
});
export const remboursementAnticipeSuccess = (data) => ({
    type: REMBOURSEMENT_ANTICIPE_SUCCESS,
    payload: data,
});
export const remboursementAnticipeFail = (error) => ({
    type: REMBOURSEMENT_ANTICIPE_FAIL,
    payload: error,
});